var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['tabPanel', _vm.index === _vm.selected ? 'tabPanel--selected' : '']},[_c('UtilityScroll',{attrs:{"height":_vm.scrollHeight}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }